// extracted by mini-css-extract-plugin
export default {"topPanel":"TopPanel_topPanel__2P0y7","container":"TopPanel_container__k6m+x","currentPage":"TopPanel_currentPage__rqCpZ"};